function run_eq(){
	var eq = $('[data-eq]');
	eq.css({minHeight:0});
	var minH = 0;	
	eq.each(function(){			
		var deskOnly = $(this).attr('data-eq') === 'desk';
		var runEq = deskOnly ? eq.length && window.outerHeight > 750 : true;
		if(runEq){
			var thisHeight = $(this).outerHeight();
			if(thisHeight > minH) minH = thisHeight;
		}
	});
	eq.css({minHeight:minH});
}

$(window).on('load', function(){
	run_eq();
});

$(window).on('resize', function(){
	run_eq();
});

$(document).ready(function(){
	$('iframe[src*="youtube"], iframe[src*="vimeo"]').parent().fitVids();
});